import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import { setStatus as setStatusAction } from '../modules';

class ModalContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.id = props.id || uuid();
  }

  render() {
    const { childComponent: ChildComponent, modals = {} } = this.props;
    return <ChildComponent id={this.id} {...this.props} {...modals[this.id]} />;
  }
}

const mapStateToProps = ({ modals }) => ({
  modals,
});

const mapDispatchToProps = dispatch => ({
  setStatus: props => dispatch(setStatusAction(props)),
});

ModalContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  modals: PropTypes.objectOf(PropTypes.any),
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
